import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BodyModule, GridModule, SharedModule } from '@progress/kendo-angular-grid';
import { PtKendoModule } from '../../../_foundation/kendo/modules/pt.kendo.module';
import { RobFigureOutstandingPage } from './rob-figure-outstanding';

@NgModule({
  declarations: [
    RobFigureOutstandingPage,
  ],
  imports: [
    IonicPageModule.forChild(RobFigureOutstandingPage),
    GridModule,
    SharedModule,
    BodyModule,
    PtKendoModule,
  ],
})
export class RobFigureOutstandingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/validation/rob-figure-outstanding/rob-figure-outstanding.module.ts